// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui'


// 自定义公共组件
import pageBody from '@/components/content-body'
import innerArea from '@/components/inner-area'
import messageList from '@/components/message-list'
import messageItem from '@/components/message-item'
import modal from '@/components/modal'
import loading from '@/components/loading'
import codeEditor from '@/components/code-editor'
import qrCode from '@/components/qr-code'


import 'element-ui/lib/theme-chalk/index.css'

import '~/css/reset.css'
import '~/css/base.css'
import '@/assets/css/jdy.css'

import { UseAxios, merge } from './common/index'
import IdentityService from '@/service/identity';

UseAxios(router)
Vue.use(ElementUI)
// Vue.use(VueResource)
merge(Vue.prototype, {
  $http: axios,
  $identity: new IdentityService(axios),
  router: router
})

Vue.config.productionTip = false

const components = [
  pageBody,
  innerArea,
  messageList,
  messageItem,
  modal,
  loading,
  codeEditor,
  qrCode
];

components.map(component => {
  Vue.component(component.name, component)
})

// 添加响应拦截器
axios.interceptors.request.use(function (config) {
  // 配置发送请求的信息
  console.log(config);
  return config;
}, function (error) {
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
  // 配置请求回来的信息
  console.log(response);
  return response;
}, function (error) {
  console.log(error);
  return Promise.reject(error);
});

//var http = axios.create({
//  timeout: 8000, /*设置请求超时时间*/
//  baseURL: 'http://192.168.400:3000',

//});

// Alter defaults after instance has been created
//http.defaults.headers.common['Authorization'] = '';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js